<template>
  <div class="GroupChatSet">
    <van-nav-bar title="群聊设置" left-arrow fixed @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group class="head-img">
      <div v-for="(it,index) in groupInfo" :key="index+'d'" v-if="it.ug_admin_id == u_id || group_manage==1">
        <van-cell class="look" value="查看更多成员" is-link @click="onSelectMember">
          <template slot="title">
            <span class="custom-title">群成员</span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <van-row type="flex" class="rowimg">
              <div
                class="imgt"
                v-for="(item,index) in groupInfo[0].group_user"
                :key="index+'d'"
                v-if="index<5"
              >
                <van-image
                  class="err-image-header"
                  round
                  width="45px"
                  height="45px"
                  :src="attach_url+item.u_headportrait"
                />
                <div>{{item.pivot.ug_group_nick?item.pivot.ug_group_nick:item.f_name.f_name?item.f_name.f_name:item.u_nickname?item.u_nickname:item.u_login_id}}</div>
              </div>
            </van-row>
          </template>
        </van-cell>
      </div>
      <div v-else>
        <van-cell class="look">
          <template slot="title">
            <span class="custom-title">群成员</span>
          </template>
          <template slot="right-icon">
            <span class="custom1-title">{{groupInfo[0].group_user.length}}个</span>
          </template>
        </van-cell>
      </div>
    </van-cell-group>
    <van-cell-group class="set">
      <label v-for="(it,index) in groupInfo" :key="index+'b'">
        <van-cell title="群聊名称" is-link :value="it.ug_name" @click="onClickUpGroupName(it.ug_id)" v-if="it.ug_admin_id == u_id || group_manage==1" />
        <van-cell title="群聊名称" v-else  :value="it.ug_name"/>
        <!-- <van-cell title="群二维码" is-link value="内容" /> -->
        <label v-for="(i,index) in it.group_user" :key="index+'c'">
          <van-cell
            title="我在群里的昵称"
            is-link
            :value="i.pivot.ug_group_nick"
            v-if="i.u_id == u_id"
            @click="onClickUpNickname(i.u_id)"
          />
        </label>
        <van-cell
          v-if="it.ug_admin_id == u_id || group_manage==1"
          title="群成员管理"
          is-link
          value
          @click="OnClickGroupManage(it.ug_id)"
        />
        <van-cell
          v-if="it.ug_admin_id == u_id || group_manage==1"
          title="群管理"
          is-link
          value
          @click="AddGroupManage(it.ug_id)"
        />
         <van-cell
          title="群公告"
          is-link
          :value="it.ug_notice"
          @click="GroupNotice(it.ug_id,it.ug_admin_id)"
        />
        <van-cell v-if="it.ug_admin_id == u_id || group_manage==1" title="群禁言">
          <van-switch v-model="banned1" @click="onSilent" />
        </van-cell>
      </label>
    </van-cell-group>
    <van-cell-group class="nodisturb">
      <van-cell title="设为置顶">
        <van-switch v-model="stick" @click="onStick" />
      </van-cell>
      <van-cell title="消息免打扰">
        <van-switch v-model="noDisturbing" @click="onNoDisturbing" />
      </van-cell>
    </van-cell-group>
    <van-cell-group class="manage">
      <label v-for="(t,index) in groupInfo" :key="index+'a'">
        <!-- 是群主才可以邀请朋友进群 -->
        <van-button
          type="info"
          v-if="t.ug_admin_id == u_id || group_manage==1"
          @click="inviteNewFriends(ug_id, u_id)"
          block
        >邀请朋友</van-button>
        <!-- 是群主显示 [解散该群]， 不是群主显示 [退出该群] -->
        <van-button v-if="t.ug_admin_id != u_id" plain @click="quitTheGroup()" block>退出该群</van-button>
        <van-button v-if="t.ug_admin_id == u_id" plain @click="dissolveGroup(ug_id)" block>解散该群</van-button>
      </label>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: "GroupChatSet",
  data() {
    return {
      ug_id: "",
      ug_admin_id:"",
      group_user: {},
      stick:
        localStorage.getItem(this.ug_id + "groupStick") == 1 ? true : false,
      noDisturbing:
        localStorage.getItem(this.ug_id + "groupNoDisturbing") == 1
          ? true
          : false,
      groupInfo: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      group_manage: localStorage.getItem("group_manage"),
      banned1:false
    };
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        ug_id: this.ug_id,
        token: this.token,
        u_id: this.u_id,
         num: Math.random()
      };
      var url = this.Conf.serverUrl + "Groups/getGroupUserInfoById";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            this.groupInfo = response.data.result;
          }
          this.banned1 = response.data.result[0].banned_state?true:false
          // console.log("aaaaaa", this.groupInfo);
          // console.log("bbbb", this.groupInfo[0].group_user.length);
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatroom",
        query: {
          ug_id: this.ug_id,
          ug_name: this.groupInfo[0].ug_name
        }
      });
    },
     GroupNotice(ug_id,ug_admin_id) {
      this.$router.push({
         name: "GroupNotice",
        query: {
          u_id: this.u_id,
          ug_id: ug_id,
          ug_admin_id:ug_admin_id
        }
      });
    },
     //群禁言
    onSilent() {
      // this.silent = true;
      var params = {
        u_id: this.u_id,
        token: this.token,
        ug_id: this.ug_id,
        banned_state: this.banned1 == false ? 1 : 0
      };
      var url = this.Conf.serverUrl + "Groups/setGroupBanned";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              break;
            case 40001:
              break;
          }
        })
        .catch(error => {});
    },
    // 设为置顶
    onStick() {
      var params = {
        ug_id: this.ug_id,
        sorting: this.stick == false ? 1 : 0,
        u_id: this.u_id,
        token: this.token
      };
      var url = this.Conf.serverUrl + "Groups/setGroupSort";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              localStorage.setItem(
                this.ug_id + "groupStick",
                response.data.sorting
              );
              break;
            case 40001:
              break;
          }
        })
        .catch(error => {});
    },
    // 消息免打扰
    onNoDisturbing() {
      // console.log(this.noDisturbing);
      localStorage.setItem(
        this.ug_id + "groupNoDistrrbing",
        this.noDisturbing == false ? 1 : 0
      );
    },
    // 查看更多群成员
    onSelectMember() {
      // if (ug_admin_id == u_id) {
      this.$router.push({
        name: "GroupMemberList",
        query: {
          ug_id: this.ug_id
        }
      });
      // } else {
      //   this.$toast("权限不够，无法查看更多成员哦!");
      // }
    },
    // 修改群名称
    onClickUpGroupName(ug_id) {
      this.$router.push({
        name: "GroupNameUpdate",
        query: {
          ug_id: ug_id
        }
      });
    },
    // 修改登录人群内昵称
    onClickUpNickname(u_id) {
      this.$router.push({
        name: "MyGroupNickUpdate",
        query: {
          u_id: u_id,
          ug_id: this.ug_id
        }
      });
    },
    // 群成员管理
    OnClickGroupManage(ug_id) {
      this.$router.push({
        name: "GroupManage",
        query: {
          ug_id: ug_id
        }
      });
    },
    //群管理
    AddGroupManage(ug_id) {
      this.$router.push({
        name: "ShowGroupManage",
        query: {
          ug_id: ug_id
        }
      });
    },
    // 邀请朋友进群
    inviteNewFriends(ug_id, friend_id) {
      //console.log(ug_id+'/'+u_id);
      this.$router.push({
        name: "InviteNewFriends",
        query: {
          ug_id: ug_id,
          friend_id: friend_id
        }
      });
    },
    // 退出群
    quitTheGroup() {
      this.$dialog
        .confirm({
          title: "退群",
          message: "你确定要退出该群吗？"
        })
        .then(() => {
          var params = {
            u_id: this.u_id,
            ug_id: this.ug_id,
            token: this.token
          };
          var url = this.Conf.serverUrl + "Groups/exitGroup";
          this.$axios
            .post(url, this.$qs.stringify(params))
            .then(response => {
              switch (response.data.code) {
                case 200:
                  this.$toast.success(response.data.msg);
                  this.$router.push({ path: this.Conf.homeUrl });
                  break;
                case 40001:
                  this.$toast.fail(response.data.msg);
                  break;
              }
            })
            .catch(error => {});
        })
        .catch(() => {
          // on cancel
        });
    },
    // 解散群 群主权利
    dissolveGroup(ug_id) {
      this.$dialog
        .confirm({
          title: "解散群",
          message: "确定要解散群？"
        })
        .then(() => {
          var params = {
            u_id: this.u_id,
            ug_id: ug_id,
            token: this.token
          };
          var url = this.Conf.serverUrl + "Groups/apiDissolveGroup";
          this.$axios
            .post(url, this.$qs.stringify(params))
            .then(response => {
              switch (response.data.code) {
                case 200:
                  this.$toast.success(response.data.msg);
                  this.$router.push({ path: this.Conf.homeUrl });
                  break;
                case 40001:
                  this.$toast.fail(response.data.msg);
                  break;
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
    this.stick =
      localStorage.getItem(this.ug_id + "groupStick") == 1 ? true : false;
    this.noDisturbing =
      localStorage.getItem(this.ug_id + "groupNoDistrrbing") == 1
        ? true
        : false;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Group/GroupChatSet.vue